// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PortfolioPage from './PortfolioPage';
import emailjs from '@emailjs/browser';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PortfolioPage />} />
      </Routes>
    </Router>
  );
}

export default App;
